const dayjs = require('dayjs')

module.exports = function (customer, order) {
  if (!customer || !customer.misc || !customer.misc.GEBDAT || !order.geburtsdatumFahrerkreisMax) return false
  const max = order.geburtsdatumFahrerkreisMax
  const min = order.geburtsdatumFahrerkreisMin || order.geburtsdatumFahrerkreisMax
  return dayjs(customer.misc.GEBDAT).isBefore(dayjs(max)) || dayjs(customer.misc.GEBDAT).isAfter(dayjs(min))
}
